import { stableKey } from '../../../lib';

export const storeNameKeys = {
  all: stableKey(['storeName']),
  suggestions: (category: string, products: string[], previousResults: string[]) =>
    stableKey(['storeName', 'suggestions', category, products, previousResults]),

  mutations: {
    suggestStoreName: () => stableKey(['storeName', 'suggest']),
    updateSiteSettings: () => stableKey(['storeName', 'updateSiteSettings']),
    updateComponent: () => stableKey(['storeName', 'updateComponent']),
    publishSite: () => stableKey(['storeName', 'publishSite']),
    connectPayment: () => stableKey(['storeName', 'connectPayment']),
    getPaymentAggregators: () => stableKey(['storeName', 'getPaymentAggregators']),
    launchStore: () => stableKey(['storeName', 'launch']),
  },
};
